module.exports = __webpack_public_path__ + "img/in-work2.9befe567.jpg";